module.exports = __webpack_public_path__ + "media/images/crypto-currencies/monero-2656781d30174496f867c1f82379cb6e.svg";